module.exports = __webpack_public_path__ + "img/Communication.59ba7499.svg";